var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxOpenFullSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12.464,
    viewBox: "0 0 15 12.464",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "box-open-full-solid",
    d: "M26.005,1.529l-.674,1.8-3.954.495L21.2,3.8a1.568,1.568,0,1,0-2.918-.365l-1.6-.2c0-.054,0-.105,0-.159a3.136,3.136,0,0,1,6.271-.081L23.805.7a1.176,1.176,0,0,1,2.2.826Zm1.644,6.7V10.27a.781.781,0,0,1-.593.759l-5.3,1.325a1.533,1.533,0,0,1-.759,0l-5.3-1.323a.786.786,0,0,1-.593-.762V8.227l3.126.894a1.569,1.569,0,0,0,1.776-.7l1.369-2.286,1.369,2.283a1.568,1.568,0,0,0,1.776.7ZM14.982,4.074a.388.388,0,0,1,.4-.213l6,.75,6-.75a.4.4,0,0,1,.4.213L28.8,6.118a.785.785,0,0,1-.485,1.1l-4,1.144a.782.782,0,0,1-.887-.35L21.378,4.611,19.335,8.016a.782.782,0,0,1-.887.35l-4-1.144a.783.783,0,0,1-.485-1.1l1.022-2.043Z",
    transform: "translate(-13.879 0.062)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxOpenFullSolid);
export default __webpack_public_path__ + "static/media/box-open-full-solid.dd218ffa6f3d9e162d9a41313ba4ef72.svg";
export { ForwardRef as ReactComponent };